import React from 'react';

const GuidesIcon = ({ width = 21, height = 24, color = 'white', ...props }) => (
  <svg width={width} height={width} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      d="M14.0771 0.00750924L21.0968 6.81455V21C21.0968 22.6569 19.7537 24 18.0968 24H3.03447C1.35858 24 0 22.6414 0 20.9655V19.8397V3.95905V2.86301C0 1.28181 1.28181 0 2.86301 0H14.0771V0.00750924ZM1.95324 3.38489V20.4213V21.9274V22.0541H19.1436V7.60484L12.9994 7.575L13.0218 1.95344H1.95324V3.38489Z"
      fill={color}
    />
  </svg>
);

export default GuidesIcon;
